<template>
  <div style="display: flex; align-items: center; flex-direction: column">
    <div class="main-grid">
      <div class="list-content">
        <router-link
          v-for="(item, index) in list"
          :key="item.id"
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          :style="`grid-area: card-${index + 1}`"
          class="news-item"
        >
          <div class="img-holder">
            <div class="img-wrap">
              <div style="position: relative; width: 100%; height: 100%">
                <ImageContainer
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                  class="img"
                />
                <div class="cat-wrapper">
                  <div class="cat-meta">{{ item.sub_category.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="meta-wrapper">
            <div class="title limited-text">
              {{ item.title }}
            </div>
            <div class="date-wrapper">
              <span class="date">{{ handleDate(item.pub_date) }},</span>
              <span class="date" style="padding-left: 0.44em">
                {{ handleTime(item.pub_date) }}</span
              >
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "ThirdBar",
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
img {
  background-color: lightgray;
}

.main-grid {
  width: 100%;
  position: relative;
  margin-top: 5em;
  display: flex;
  justify-content: center;

  .list-content {
    --card-border-radius: 16.625rem;

    width: var(--width-content);
    display: grid;
    position: relative;
    grid-template-columns: repeat(8, 1fr);
    column-gap: 5%;
    grid-template-areas:
      "card-1  card-1  card-1  card-1  card-1  card-2  card-2  card-2"
      "card-1  card-1  card-1  card-1  card-1  card-3  card-3  card-3"
      "card-1  card-1  card-1  card-1  card-1  card-4  card-4  card-4"
      "card-1  card-1  card-1  card-1  card-1  card-4  card-4  card-4"
      "card-5  card-5  card-6  card-6  card-7  card-7  card-8  card-8"
      "card-9  card-9  card-9  card-12 card-12 card-12 card-12 card-12"
      "card-10 card-10 card-10 card-12 card-12 card-12 card-12 card-12"
      "card-11 card-11 card-11 card-12 card-12 card-12 card-12 card-12"
      "card-11 card-11 card-11 card-12 card-12 card-12 card-12 card-12";

    .news-item {
      &:hover {
        img {
          transform: scale(1.14);
        }
      }

      .img-holder {
        height: 30vw;
        width: 100%;

        .img-wrap {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          height: inherit;
          max-width: 60%;
          overflow: hidden;
          border-radius: 0px var(--card-border-radius) 0px 0px;

          .img {
            width: 100%;
            height: 100%;
            border-radius: inherit;
            overflow: hidden;
            object-fit: cover;
            transition: all 0.4s ease;
          }
        }

        .cat-wrapper {
          position: absolute;
          right: 0;
          bottom: 6.25rem;
          display: flex;
          align-items: center;
          background-color: var(--background-color);
          height: 1.6em;
          font-family: Open Sans;
          border-radius: 4px 0px 0px 4px;

          .cat-meta {
            display: flex;
            align-items: center;
            justify-content: center;

            &:first-child {
              font-weight: 600;
              text-transform: uppercase;
              padding: 0 0.375rem;
            }
          }
        }
      }

      .meta-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
          font-family: Roboto;
          width: 80%;
          text-align: center;
          font-size: 1.625em;
          line-height: 1.125em;
          padding-top: 0.625rem;
        }

        .date-wrapper {
          font-weight: 300;
          font-size: 0.875em;
          padding-top: 0.75em;
          opacity: 0.8;
          font-family: Open Sans;
        }
      }

      &:last-child {
        overflow: hidden;
        .img-holder {
          .img-wrap {
            // bottom: 104px;
            top: unset;
            right: 0;
            left: unset;
            border-radius: 0 0 0px var(--card-border-radius);
          }

          .cat-wrapper {
            left: 0;
            right: unset;
            top: 6.25rem;
            bottom: unset;
            border-radius: 0 4px 4px 0;
          }
        }

        .title {
          --snup: 2;
        }
      }

      &:nth-child(9),
      &:nth-child(10),
      &:nth-child(11),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        // height: 150px;
        height: 8vw;
        display: flex;

        .img-holder {
          height: 8vw;
          width: 8vw;
          margin-right: 1rem;

          .img-wrap {
            position: relative;
            top: 0;
            left: 0;
            width: inherit;
            max-width: unset;
            border-radius: 4px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .cat-wrapper {
            top: 0;
            left: 0;
            right: unset;
            border-radius: 0 0 4px 0;
          }
        }

        .meta-wrapper {
          width: 100%;
          justify-content: space-between;
          align-items: flex-start;

          .title {
            --snup: 4;
            font-family: Roboto;
            width: 100%;
            text-align: start;
            font-size: 1.25em;
            font-weight: 500;
            line-height: 1.5em;
            padding-top: 0;
          }

          .date-wrapper {
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }

      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        margin: 130px 0;

        .img-holder {
          width: 100%;
          height: unset;
          margin-right: 1rem;
          padding-top: 59.09%; /* 22:13 Aspect Ratio */
          max-width: unset;
          position: relative;

          .img-wrap {
            top: 0;
            width: 100%;
            height: 100%;
            left: 0;
            width: inherit;
            max-width: unset;
            border-radius: 4px;

            .img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .cat-wrapper {
            top: 0;
            left: 0;
            right: unset;
            border-radius: 0 0 4px 0;
          }
        }

        .meta-wrapper {
          width: 100%;
          justify-content: space-between;
          align-items: flex-start;
          padding-top: 10px;

          .title {
            --snup: 4;
            font-family: Roboto;
            width: 100%;
            text-align: start;
            font-size: 1.25em;
            font-weight: 500;
            line-height: 1.5em;
            padding-top: 0;
          }

          .date-wrapper {
            opacity: 0.8;
            font-family: Open Sans;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 2000px) {
  .main-grid {
    .list-content {
      position: unset;
    }
  }
}

@media screen and(max-width: 992px) {
  .main-grid {
    .list-content {
      width: 100%;
      --card-border-radius: 10rem;
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas:
        "card-1  card-1  card-1  card-1  card-2  card-2"
        "card-1  card-1  card-1  card-1  card-3  card-3"
        "card-1  card-1  card-1  card-1  card-4  card-4"
        "card-5  card-5  card-5  card-6  card-6  card-6"
        "card-7  card-7  card-10 card-10 card-10 card-10"
        "card-8  card-8  card-10 card-10 card-10 card-10"
        "card-9  card-9  card-10 card-10 card-10 card-10"
        "card-11 card-11 card-11 card-12 card-12 card-12";

      .news-item {
        position: relative;

        .img-holder {
          height: 320px;

          .img-wrap {
            max-width: unset;
            .cat-wrapper {
              bottom: 2.8rem;
            }
          }
        }

        .meta-wrapper {
          .title {
            width: 100%;
            font-size: 1.25rem;
            line-height: 1.4em;
          }
        }

        &:nth-child(1),
        &:nth-child(7),
        &:nth-child(8),
        &:nth-child(9),
        &:nth-child(11),
        &:nth-child(5) {
          padding-left: 5vw;
        }

        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(6),
        &:nth-child(10),
        &:nth-child(12) {
          padding-right: 5vw;
        }

        &:nth-child(5),
        &:nth-child(6) {
          margin-top: 25px;
          margin-bottom: 54px;
        }

        &:nth-child(9),
        &:nth-child(8),
        &:nth-child(7),
        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
          flex-direction: column;
          height: 140px;
          margin-bottom: 1.4rem;
          margin-top: 0;

          .img-holder {
            width: auto;
            height: auto;
            padding-top: 0;

            .img-wrap {
              position: relative;
              .img {
                display: none;
              }
            }

            .cat-wrapper {
              position: relative;
              opacity: 0.8;

              .cat-meta {
                padding: 0;
              }
            }
          }

          .meta-wrapper {
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;
            padding: 0;

            .title {
              padding-top: 10px;
            }

            .date-wrapper {
              padding-top: 6px;
            }
          }
        }

        &:nth-child(10) {
          display: block;
          height: unset;
          overflow: hidden;

          .img-holder {
            height: 320px;
            width: 100%;

            .img-wrap {
              position: absolute;
              border-radius: 0 0 0px var(--card-border-radius);

              .cat-wrapper {
                top: 2.8rem;
              }
            }
          }

          .meta-wrapper {
            align-items: center;

            .title {
              padding-top: 0.625rem;
              text-align: center;
              font-size: 1.25rem;
              line-height: 1.4em;
            }
          }
        }

        &:nth-child(11),
        &:nth-child(12) {
          display: block;
          margin: 25px 0;

          .img-holder {
            position: relative;
            width: 100%;
            height: unset;
            margin-right: 1rem;
            padding-top: 59.09%; /* 22:13 Aspect Ratio */
            max-width: unset;

            .img-wrap {
              position: absolute;
              top: 0;
              left: 0;
              width: inherit;
              height: 100%;
              max-width: unset;
              border-radius: 4px;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .cat-wrapper {
              top: 0;
              left: 0;
              right: unset;
              border-radius: 0 0 4px 0;
            }
          }

          .meta-wrapper {
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;
            padding-top: 10px;

            .title {
              --snup: 4;
              font-family: Roboto;
              width: 100%;
              text-align: start;
              font-size: 1.25em;
              font-weight: 500;
              line-height: 1.5em;
              padding-top: 0;
            }

            .date-wrapper {
              opacity: 0.8;
              font-family: Open Sans;
            }
          }
        }
      }
    }
  }
}

@media screen and(max-width: 768px) {
  .main-grid {
    .list-content {
      --card-border-radius: 8rem;
      grid-template-columns: repeat(3, 1fr);
      row-gap: 1rem;
      grid-template-areas:
        "card-1  card-1  card-2"
        "card-1  card-1  card-3"
        "card-4  card-6  card-6"
        "card-5  card-6  card-6"
        "card-7  card-7  card-8"
        "card-7  card-7  card-9"
        "card-10 card-12 card-12"
        "card-11 card-12 card-12";

      .news-item {
        .img-holder {
          height: 220px;
        }

        .meta-wrapper {
          .title {
            text-align: start;
            font-size: 1rem;
          }
        }

        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4),
        &:nth-child(8),
        &:nth-child(9) {
          .meta-wrapper {
            .title {
              font-size: 1rem;
            }
          }
        }

        &:nth-child(1),
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(7),
        &:nth-child(10),
        &:nth-child(11) {
          padding-left: 2vw;
          padding-right: 0;
        }

        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(6),
        &:nth-child(8),
        &:nth-child(9),
        &:nth-child(12) {
          padding-left: 0;
          padding-right: 2vw;
        }

        &:nth-child(5),
        &:nth-child(10),
        &:nth-child(11) {
          flex-direction: column;
          height: 140px;
          margin-bottom: 1.4rem;
          margin-top: 0;
          overflow: visible;

          .img-holder {
            padding-top: 0;
            width: auto;
            height: auto;

            .img-wrap {
              border-radius: 0;
              position: relative;

              .img {
                display: none;
              }
            }

            .cat-wrapper {
              position: relative;
              opacity: 0.8;
              top: 0 !important;

              .cat-meta {
                padding: 0;
              }
            }
          }

          .meta-wrapper {
            width: 100%;
            justify-content: space-between;
            align-items: flex-start;
            padding: 0;

            .title {
              padding-top: 10px;
              text-align: start;
              font-size: 1rem;
            }

            .date-wrapper {
              padding-top: 6px;
            }
          }
        }

        &:nth-child(6),
        &:nth-child(12) {
          .img-holder {
            height: 220px;
            padding-top: 0;
            position: unset;

            .img-wrap {
              position: absolute;
              height: inherit;
              border-radius: 0px 0 0 var(--card-border-radius);

              .cat-wrapper {
                top: 2.8rem;
              }
            }
          }

          .meta-wrapper {
            align-items: center;

            .title {
              padding-top: 0.625rem;
              text-align: start;
              font-size: 1rem;
              line-height: 1.4em;
            }
          }
        }

        &:nth-child(7) {
          .img-holder {
            height: 220px;
            padding-top: 0;
            margin-right: 0;
            position: unset;

            .img-wrap {
              position: absolute;
              // padding-top: 45%;
              left: 0;
              top: 0;
              height: inherit;
              width: 100%;
              border-radius: 0px var(--card-border-radius) 0 0;

              .img {
                display: block;
              }

              .cat-wrapper {
                top: unset;
                position: absolute;
                right: 0;
                left: unset;
                opacity: 1;
                border-radius: 4px 0 0 4px;

                .cat-meta {
                  &:first-child {
                    padding: 0 0.375rem;
                  }
                }
              }
            }
          }

          .meta-wrapper {
            align-items: center;

            .title {
              padding-top: 0.625rem;
              text-align: start;
              font-size: 1rem;
              line-height: 1.4em;
            }
          }
        }
      }
    }
  }
}
</style>
